

import React , { useRef }from 'react';
import emailjs from '@emailjs/browser';

// const SERVICE_ID = process.env.SERVICE_ID
// const TEMPLATE_ID = process.env.TEMPLATE_ID
// const PUBLIC_KEY = process.env.PUBLIC_KEY

const Contact = () => {


  const form = useRef();

  function handleSubmit(e){
    e.preventDefault()
    emailjs.sendForm('service_gqxud8d', 'template_csap3t6', form.current, 'wnHRsfozieKRz_zdY')
        .then((result) => {
            alert("Thank you for contacting me. Please await for reply soon.");
        }, (error) => {
            console.log(error)
            alert("Error has been occured due to some reason. Please try again...")
        });
    window.location.reload()
}

  return (
    <div className='contactSection'>
      <h3>Get in Touch</h3>
      <small className='greyText'>Have questions about Fashioniste? We'd love to hear from you!</small>
      <p className='greyText'>Share your feedback or reach out to our team</p>
      <form ref={form} onSubmit={handleSubmit}>
        <div className="info">
            <label>
            Name:
            <input className='input' type="text" name="name" required  />
            </label>
            <br />
            <label>
            Email:
            <input className='input' type="email" name="email" required/>
            </label>
            <br />
        </div>
        <label>
          Message:
          <textarea className='input-textarea' name="message" required />
        </label>
        <br />
        <button className='submitBtn' type="submit">Send</button>
      </form>
    </div>
  );
};

export default Contact;
